import api from './api';

// Consulta o historico de baixas de titulos antecipados enviadas ao ERP (Bluesoft).
// ModuloId=90153 (dbo.fnCalculaModuloId('ErpsApisControlesBaixasTitulosAntecipados')).
// Somente leitura na tela — nao ha cadastro/alteracao/remocao manual desse controle.

export async function consultar({
  paginaInicial = 1,
  itensPorPagina = 50,
  status = '',
} = {}) {
  const qs = new URLSearchParams();
  qs.append('paginaInicial', paginaInicial);
  qs.append('itensPorPagina', itensPorPagina);
  if (status) qs.append('status', status);
  return api.get(`ErpsApisControlesBaixasTitulosAntecipados/Consultar?${qs.toString()}`);
}

// Enum backend enumErpsApisControlesBaixasTitulosAntecipadosStatus (JsonStringEnumConverter -> string no JSON)
export const STATUS_OPTIONS = [
  { value: 'AguardandoEnvio', label: 'Aguardando Envio', color: '#FB8832' },
  { value: 'Baixado', label: 'Baixado', color: '#4CAF50' },
  { value: 'Erro', label: 'Erro', color: '#F44336' },
];

// Enum backend enumErpsApisControlesBaixasTitulosAntecipadosSituacao
export const SITUACAO_LABELS = {
  AguardandoEnvio: 'Aguardando Envio',
  Sucesso: 'Sucesso',
  ErroToken: 'Erro ao obter token',
  ErroUrlDuplicataNegociacaoAbrir: 'Erro ao abrir negociação',
  ErroUrlDuplicataNegociacaoLiberar: 'Erro ao liberar negociação',
  ErroUrlDuplicataAnteciparTitulo: 'Erro ao antecipar título',
  ErroUrlDuplicataTrocarCedente: 'Erro ao trocar cedente',
  ErroVinculoNaoInformado: 'Vínculo não informado',
  ErroPerfilERPInvalido: 'Perfil ERP inválido',
};
